import { memo } from "react";
function EndTripIcon({color="#CF0000"}) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.6667 0.333008H12V7.83301H13.6667V0.333008Z" fill={color} fillOpacity="0.7"/>
    <path d="M2.00004 0.333008H0.333374V13.6663H2.00004V0.333008Z" fill={color} fillOpacity="0.7"/>
    <path d="M7.83342 0.333008H6.16675V3.66634H7.83342V0.333008Z" fill={color} fillOpacity="0.7"/>
    <path d="M7.83342 5.33301H6.16675V8.66634H7.83342V5.33301Z" fill={color} fillOpacity="0.7"/>
    <path d="M7.83342 10.333H6.16675V13.6663H7.83342V10.333Z" fill={color} fillOpacity="0.7"/>
    <path d="M15.7501 10.675L14.5751 9.5L12.8334 11.2417L11.0917 9.5L9.91675 10.675L11.6584 12.4167L9.91675 14.1583L11.0917 15.3333L12.8334 13.5917L14.5751 15.3333L15.7501 14.1583L14.0084 12.4167L15.7501 10.675Z" fill={color}/>
    </svg>
  );
}

export default memo(EndTripIcon);